import {Record} from 'immutable';

import {ShortlistCountry} from 'web-app/util/countries-shortlist';

class Address extends Record<{
    city?: string | null;
    zip?: string | null;
    street?: string | null;
    country?: string | null;
    state?: string | null;
    countryInput?: string | null;
}>({
    city: null,
    zip: null,
    street: null,
    country: null,
    state: null,
    countryInput: null,
}) {}

class Doctor extends Record<{
    name?: string;
    phone?: string;
    address?: Address;
    country?: string;
    state?: string;
}>({
    name: '',
    phone: '',
    address: new Address(),
    country: '',
    state: '',
}) {}

function fromAPI(data) {
    return new Doctor({
        name: data.name,
        phone: data.phone,
        address: new Address({
            city: data.addressCity,
            zip: data.addressZip,
            street: data.addressStreet,
            country: data.addressCountry,
            state: data.addressState,
            countryInput: '',
        }),
    });
}

const toAPI = (doctor: Doctor) => {
    const payloadToSend = {
        doctorName: doctor.name,
        doctorPhone: doctor.phone,
        doctorAddressCity: doctor?.address?.city,
        doctorAddressZip: doctor?.address?.zip,
        doctorAddressStreet: doctor?.address?.street,
        doctorAddressCountry: doctor?.address?.country,
    };

    // If the country is 'US', we need to include the state in the request as well
    if (doctor?.address?.country === ShortlistCountry.US) {
        return {
            ...payloadToSend,
            doctorAddressState: doctor.address.state,
        };
    }
    // If the country is 'Other', we send whatever is put in the country text input as value for the 'doctorAddressCountry'
    else if (doctor?.address?.country === ShortlistCountry.OTHER) {
        return {
            ...payloadToSend,
            doctorAddressCountry: doctor.address.countryInput,
        };
    }
    // If the country is neither US nor 'Other', we send the payload above
    else {
        return payloadToSend;
    }
};

export default {
    record: Doctor,
    default: new Doctor(),
    fromAPI,
    toAPI,
};
